module.exports = __webpack_public_path__ + "staticcomp/img/content_6.95bda3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/10/content_6.jpg
// module id = 5AnW
// module chunks = 39